<template>
  <div class="privacy">
    <p class="warning">
      <span class="weight">【特别提示】</span>在申请注册成为翡翠王朝用户之前，请您仔细阅读并遵循《翡翠王朝用户协议》（以下简称“本协议”）并务必审慎阅读、充分理解各条款内容，阅读过程中，如果您有任何疑问，可联系我们客服进行咨询，如您不同意我们的说明，您应立即停止注册程序。
    </p>
    <h2>1.定义</h2>
    <h3>1.1 翡翠王朝</h3>
    <p>翡翠王朝是翡翠王朝平台的经营者，即云南翡翠王朝网络科技有限公司。</p>
    <h3>1.2 翡翠王朝平台</h3>
    <p>
      是指云南翡翠王朝网络科技有限公司经营的电商平台，包括但不限于翡翠王朝网站（域名 http://www.jaadee.com）及相关的客户端、小程序。
    </p>
    <h3>1.3 翡翠王朝平台规则</h3>
    <p>
      包括所有翡翠王朝平台已经发布或将来可能发布、修订的各类规则、规范、规则解读、实施细则、通知、公告、产品说明等。
    </p>
    <h3>1.4 翡翠王朝平台服务</h3>
    <p>
      翡翠王朝王朝向您提供的包括但不限于协议第四条约定的各项服务。
    </p>
    <h3>1.5 商品</h3>
    <p>
      指用户在翡翠王朝平台上可合法交易的实物或数字化虚拟产品或服务。
    </p>
    <h2>2.协议范围</h2>
    <p>
      2.1 本协议甶您与翡翠王朝共同缔结，本协议具有合同效力。
    </p>
    <p>
      2.2
      除另行明确声明外，翡翠王朝平台服务包含任何翡翠王朝及其关联公司提供的基于互联网以及移动网的相关服务，且均受本协议约束。如果您不同意本协议的约定，您应立即停止注册/激活程序或停止使用翡翠王朝平台服务。若您继续使用本服务，即表示您接受平台所有的协议内容。
    </p>
    <p>
      2.3 发生争议时，您可根据具体使用的服务种类及对您权益产生影响的具体行为对象确定履约主体即争议相对方。
    </p>
    <p>
      2.4
      翡翠王朝有权根据需要不定期地制订、修改本协议及/或各类规则。若您继续使用翡翠王朝平台服务或未在相应特定生效日期前反馈意见的，即表示您已经阅读、理解并接受经修订的协议和规则。若您不同意相关变更，应当立即停止使用翡翠王朝平台服务。
    </p>
    <h2>3.账户注册与使用</h2>
    <h3>3.1 用户资格</h3>
    <p>
      您确认，在您完成注册程序或以其他翡翠王朝允许的方式实际使用翡翠王朝平台服务时，您应当是具备完全民事行为能力和完全民事权利的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果。
    </p>
    <p>
      此外，您还需确保您不是任何国家、地区或国际组织实施的贸易限制、经济制裁或其他法律法规限制的对象，也未直接或间接为前述对象提供资金、商品或服务，否则您应当停止使用翡翠王朝平台服务，同时您应理解违反前述要求可能会造成您无法正常注册及使用翡翠王朝平台服务。
    </p>
    <h3>3.2 账户说明</h3>
    <h3>3.2.1 账户获得</h3>
    <p>
      当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得翡翠王朝平台账户，成为翡翠王朝平台用户。
    </p>
    <p>
      翡翠王朝平台只允许每位用户使用一个翡翠王朝平台账户。如您存在不当注册或不当使用多个翡翠王朝平台账户的情形，翡翠王朝平台可根据翡翠王朝平台规则采取冻结或关闭账户、取消订单、拒绝提供服务等措施。如因此给翡翠王朝平台及相关方造成损失的，您还应承担赔偿责任。
    </p>
    <h3>3.2.2 账户使用</h3>
    <p>
      您有权使用您设置或确认的翡翠王朝会员名、微信号、手机号码（以下简称“账户名称”）及您的验证码（手机号及验证码合称“账户”）登录翡翠王朝平台。
    </p>
    <p>
      您的账户需遵守中华人民共和国有关法律和法规，不得利用翡翠王朝平台制作、上传、复制、发布、传播或者转载如下性质的内容：
    </p>
    <p>
      （1）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一；
    </p>
    <p>
      （2）损害国家荣誉和利益；
    </p>
    <p>
      （3）破坏民族团结；
    </p>
    <p>
      （4）宣扬邪教和封建迷信；
    </p>
    <p>
      （5）散布虚假、不准确、或者存在误导性的骚扰性信息，扰乱社会秩序，破坏社会稳定；
    </p>
    <p>
      （6）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪；
    </p>
    <p>
      （7）恐吓、侮辱或者诽谤他人，侵害他人合法权益；
    </p>
    <p>
      （8）存在可能破坏、篡改、删除、影响翡翠王朝平台正常运行或未经授权秘密获取翡翠王朝平台及平台用户数据、个人信息的病毒、木马、爬虫等恶意软件、程序代码等；
    </p>
    <p>
      （9）违反宪法所规定的基本原则或被法律、行政法规禁止的其他内容的信息。
    </p>
    <h3>3.2.3 账户转让 </h3>
    <p>
      由于用户账户关联用户信用信息，仅当有法律明文规定、司法裁定或经翡翠王朝同意，并符合翡翠王朝平台规则规定的用户账户转让流程的情况下，您可进行账户的转让。您的账户一经转让，该账户项下权利义务，包括财产性权利和义务一并转移。除前述情况外，您的账户不得以任何方式转让，否则翡翠王朝平台有权追究您的违约责任，且由此产生的责任及后果均由您自行承担。
    </p>
    <h3>3.3 用户信息</h3>
    <p>
      在注册及使用翡翠王朝平台时，您应当依照法律法规要求，按相应页面的提示真实、准确、完整地提供您的资料，并于资料信息变更时及时更新，以保证您所提交资料的真实、及时、完整和准确。如平台有合理理由怀疑您提供的资料错误、不实、过时或不完整的，翡翠王朝有权向您发出询问及/或要求改正的通知，并有权直接做出删除相应资料的处理，直至中止、终止对您提供部分或全部翡翠王朝平台服务。翡翠王朝对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。
    </p>
    <p>
      您应当准确填写并及时更新您提供的联系电话、联系地址、邮政编码、账户信息等联系方式，以便翡翠王朝与您进行有效联系或翡翠王朝为您提供相应服务，因通过这些联系方式无法与您取得联系，导致您在使用翡翠王朝平台服务过程中产生任何损失或增加费用的，应由您完全独自承担。
    </p>
    <p>
      您了解并同意，您有义务保证您提供的包括联系方式在内的个人信息的真实性、有效性、完整性及准确性。如有任何变更或需要更新的，您应立即按翡翠王朝的要求进行操作。
    </p>
    <h3>3.4 账户安全</h3>
    <p>
      您须自行负责对您的登录名和密码保密，且须对您在该登录名和密码下发生的所有活动（包括但不限于信息披露、发布信息、网上点击同意等）承担责任。如发现任何人未经授权使用您的登录名和密码，或发生违反保密规定的任何其他情况，您应立即通知翡翠王朝，并授权翡翠王朝处理。
    </p>
    <p>
      使用您的登录名和密码进行的任何操作、发出的任何指令均视为您本人做出，该行为的法律后果将由您本人承担。因您的原因造成的账户、密码等信息被冒用、盗用或非法使用，由此引起的一切风险、责任、损失、费用等应甶您自行承担。
    </p>
    <h2>4.翡翠王朝平台服务及规范</h2>
    <p>
      4.1 通过翡翠王朝提供的翡翠王朝平台服务，您可以在翡翠王朝平台上进行商品浏览、商品收藏、商品查询、商品购买与评价、交易争议处理、参加翡翠王朝组织的活动以及使用其它信息服务及技术服务，具体以平台提供的服务内容为准。
    </p>
    <p>
      4.2
      您了解并同意，翡翠王朝有权应政府部门及公检法机关的要求，向其提供您向翡翠王朝提供的用户信息和交易记录等必要信息。如您涉嫌侵犯他人知识产权及其他合法权益，则翡翠王朝亦有权在初步判断涉嫌侵权行为存在的情况下，向权利人提供您必要的信息，并依照法律规定及平台规定采取相应的措施限制您在平台上的相关权利。
    </p>
    <p>
      4.3
      您了解并同意，因翡翠王朝需要不定期地对平台以及相关设备进行维护或升级，或者因黑客攻击、电脑病毒入侵、政府管制等情况而造成翡翠王朝平台服务的中断，翡翠王朝为此不承担任何责任。除突发状况外，翡翠王朝将就维护或升级的时间向您提前作出通知。
    </p>
    <h2>
      5.支付交易
    </h2>
    <p>
      5.1 翡翠王朝不会以任何名义或者形式通过手机号向您索要财产。如果在使用过程中有其他陌生人给你电话或者发短信向您索要财款，请您及时拒绝并向我们举报该账号，我们会依法向国家主管部门进行报案。
      在订单交易过程中向翡翠王朝付款，请认准以下付款方式：
    </p>
    <p>
      （1）通过APP内的在线付款方式进行在线支付；
    </p>
    <p>
      （2）通过与APP内客服交流获取付款卡号，并确定持卡人姓名，我们客服在交易过程中也会提醒。
    </p>
    <h2>
      6.知识产权
    </h2>
    <p>
      6.1
      翡翠王朝平台提供的服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。
    </p>
    <p>
      6.2
      通过翡翠王朝平台发布的所有这些资料或资料的任何部分仅可作为私人和非商业用途而保存在某台计算机内。翡翠王朝不就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿，以任何形式，向用户或任何第三方负责。
    </p>
    <p>
      6.3
      翡翠王朝反对并打击侵犯知识产权的行为，您在未经相关权利人同意时，请勿将其作品全部或部分复制上传或发布到翡翠王朝平台。如您侵犯了第三方的知识产权，将由您自行承担相应的法律责任，翡翠王朝有权在收到第三方证实后，依据相应法律法规及平台规则进行删除相关内容、封号等处理。
    </p>
    <h2>
      7.协议终止
    </h2>
    <p>
      7.1 翡翠王朝可能会对提供的服务内容进行不定时的变更，也可能会中断、中止或终止服务。
    </p>
    <p>
      7.2 如发生下列任何一种情形，翡翠王朝有权不经通知而中断或终止向您提供的服务：
    </p>
    <p>
      （1）根据法律规定您应提交真实信息，而您提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；
    </p>
    <p>
      （2）您涉嫌违反相关法律法规规定；
    </p>
    <p>
      （3）按照法律规定或主管部门的要求；
    </p>
    <p>
      （4）出于安全的原因或其他必要的情形；
    </p>
    <p>
      （5）本协议（含规则）变更时，您明示不愿接受新的服务协议的；
    </p>
    <p>
      （6）在满足翡翠王朝账户注销条件时，通过联系翡翠王朝平台注销您的账户；
    </p>
    <p>
      （7）本协议中明确约定的其他情形。
    </p>
    <p>
      7.3 本协议解除或终止后，对于您在本协议存续期间产生的尚未结束的交易订单，翡翠王朝可以不删除该项交易，但您应当继续履行本协议及订单内容直至该交易订单交易成功，且您应承担由此产生的任何损失和可能增加的费用。
    </p>
    <h2>
      8.法律适用与争议解决
    </h2>
    <p>
      8.1 本协议的成立、生效、履行、解释与纠纷解决，适用中华人民共和国大陆地区法律法规，并且排除一切冲突法规定的适用。
    </p>
    <p>
      8.2 因本协议产生之争议，应友好协商，协商不成的，任何一方均有权向翡翠王朝所在地法院提起诉讼。
    </p>
    <h2>
      9.其他
    </h2>
    <p>
      9.1 如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
    </p>
    <p>
      9.2 如您对本协议有任何问题或建议，请在工作时间联系翡翠王朝客服部门。
    </p>
    <p class="warning last">
      <span class="weight">感谢您的耐心阅读！</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'privacy',
  components: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>

.privacy {
  padding: 0.2rem 0.3rem;
  font-size: 0.187rem;
  color: rgba(78, 78, 78, 1);
  line-height: 0.267rem;
  background-color: rgba(255, 255, 255, 1);

  h2, h3 {
    text-align: left;
    margin-bottom: 0.1rem;
  }

  h2 {
    font-size: 0.24rem;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 0.333rem;
  }

  h3 {
    text-indent: 0.3rem;
  }

  p {
    text-indent: 0.3rem;
    text-align: left;
    margin-bottom: 0.1rem;

    .weight {
      font-size: 0.2rem;
      color: rgba(0, 0, 0, 1)
    }
  }

  .warning {
    font-size: 0.187rem;
    color: rgba(109, 109, 109, 1);
  }
  .last {
    text-indent: 0;
  }
}

</style>
